import { ComponentsEnum } from '../../types';
import INavigationItem from '../../types/INavigationItem';

const NavigationCheckPrivate: Array<INavigationItem> = [
  { title: 'Haushalt & Grösse Wohnung', id: ComponentsEnum.HOUSE_HOLD },
  { title: 'PLZ', id: ComponentsEnum.POST_CODE },
  { title: 'Nachzahlung oder Gutschrift', id: ComponentsEnum.PAYMENT_TYPE },
  { title: 'Zeitraum & Zustellung', id: ComponentsEnum.PERIOD },
  { title: 'Rechtsschutzversicherung', id: ComponentsEnum.LEGAL },
  { title: 'Prüfpaket', id: ComponentsEnum.PACKAGE },
  { title: 'Registrierung', id: ComponentsEnum.REGISTER },
  { title: 'Ihre Hinweise', id: ComponentsEnum.COMMENTS },
  { title: 'Nebenkostenabrechnung', id: ComponentsEnum.STATEMENT },
  { title: 'Mietvertrag', id: ComponentsEnum.CONTRACT },
  { title: 'Fragen', id: ComponentsEnum.ASK },
  { title: 'Expertenprüfung', id: ComponentsEnum.EXPERT_CHECK },
  { title: 'Prüfergebnis', id: ComponentsEnum.TEST_RESULT },
];

export default NavigationCheckPrivate;
